import React from "react";

const Drawer = ({ children, close, show, title, header = true }) => {
  let drawerClasses = "side-drawer";

  if (show) drawerClasses += " open";

  return (
    <>
      <div className={drawerClasses}>
        <div className="drawer-main">
          {header && (
            <div className="drawer-head">
              <span className="drawer-title">{title}</span>
              <button onClick={close} className="close">
                <img
                  className="icon-red"
                  src="/img/new-icons/red-cross.svg"
                  alt="dismiss"
                />
              </button>
            </div>
          )}

          {children}
        </div>
      </div>
      {show ? <Backdrop close={close} /> : null}
    </>
  );
};

const Backdrop = (props) => {
  return <div className="drawer-backdrop" onClick={props.close} />;
};

export default Drawer;
